function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
import { property as r } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/property.js";
import { state as l } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/state.js";
import { TestableLitElement as u } from "../../../utils/components/testable-lit-element/testable-lit-element.js";
var _ = Object.defineProperty,
  s = function s(c, t, a, n) {
    for (var e = void 0, h = c.length - 1, D; h >= 0; h--) (D = c[h]) && (e = D(t, a, e) || e);
    return e && _(t, a, e), e;
  };
var i = /*#__PURE__*/function (_u) {
  function i() {
    var _this;
    _classCallCheck(this, i);
    _this = _callSuper(this, i), _this._todaysDate = new Date(), _this.range = !1, _this.startDate = null, _this.endDate = null, _this.selectedDate = null, _this.min = null, _this.max = null, _this.sundayStart = !1, _this.locale = navigator.language, _this._selectedDate = null, _this._startDate = null, _this._endDate = null, _this._localizedDaysOfWeek = _this.getLocalizedDaysOfWeek(), _this._localizedMonths = _this.getLocalizedMonths(), _this._years = [], _this._yearsBatchSize = 15, _this._todaysDate.setHours(0, 0, 0, 0), _this._contextDate = new Date(_this._todaysDate), _this._contextMonth = _this._contextDate.getMonth(), _this._contextYear = _this._contextDate.getFullYear(), _this._contextDays = _this.getDatesForMonth(), _this._years = _this.loadInitialYearsBatch();
    return _this;
  }
  _inherits(i, _u);
  return _createClass(i, [{
    key: "updated",
    value: function updated(t) {
      t.has("_contextDate") && (this._contextDate.getMonth() !== this._contextMonth && (this._contextMonth = this._contextDate.getMonth(), this._contextDays = this.getDatesForMonth()), this._contextDate.getFullYear() !== this._contextYear && (this._contextYear = this._contextDate.getFullYear(), this._contextDays = this.getDatesForMonth())), t.has("selectedDate") && this.selectedDate && (this.setSelectedDate(this.selectedDate), this._contextDate = this.selectedDate), t.has("startDate") && this.startDate && (this.setRangeStart(this.startDate), this.isSameDate(this._contextDate, this._todaysDate) && (this._contextDate = this.startDate)), t.has("endDate") && this.endDate && this.setRangeEnd(this.endDate), (t.has("min") || t.has("max")) && (this._years = this.loadInitialYearsBatch(), this.requestUpdate()), t.has("sundayStart") && (this._localizedDaysOfWeek = this.getLocalizedDaysOfWeek(), this._contextDays = this.getDatesForMonth(), this.requestUpdate()), t.has("locale") && ((this.locale === void 0 || this.locale === "") && (this.locale = navigator.language), this._localizedDaysOfWeek = this.getLocalizedDaysOfWeek(), this._localizedMonths = this.getLocalizedMonths(), this.requestUpdate());
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      _superPropGet(i, "connectedCallback", this, 3)([]), this.selectedDate && (this._selectedDate = new Date(this.selectedDate), this._contextDate = this._selectedDate), this.startDate && this.endDate && (this._startDate = new Date(this.startDate), this._endDate = new Date(this.endDate), this._contextDate = this._startDate);
    }
  }, {
    key: "currentMonthName",
    get: function get() {
      return new Intl.DateTimeFormat(this.locale, {
        month: "long"
      }).format(this._contextDate);
    }
  }, {
    key: "getLocalizedDaysOfWeek",
    value: function getLocalizedDaysOfWeek() {
      var t = [],
        a = new Intl.DateTimeFormat(this.locale, {
          weekday: "short"
        }),
        n = this.sundayStart ? 5 : 6,
        e = new Date(2025, 0, n);
      for (var h = 0; h < 7; h++) {
        var D = new Date(e);
        D.setDate(e.getDate() + h), t.push(a.format(D));
      }
      return t;
    }
  }, {
    key: "getLocalizedMonths",
    value: function getLocalizedMonths() {
      var t = [],
        a = new Intl.DateTimeFormat(this.locale, {
          month: "short"
        });
      for (var n = 0; n < 12; n++) {
        var e = new Date(this._todaysDate.getFullYear(), n, 1);
        t.push({
          dataValue: n,
          selectorText: a.format(e).toLocaleUpperCase()
        });
      }
      return t;
    }
  }, {
    key: "loadInitialYearsBatch",
    value: function loadInitialYearsBatch() {
      var t = [],
        a = Math.floor(this._yearsBatchSize / 2),
        n = this.min ? Math.max(this.min.getFullYear(), this._contextYear - a) : this._contextYear - a,
        e = this.max ? Math.min(this._contextYear + a, this.max.getFullYear()) : this._contextYear + a;
      for (var h = n; h <= e; h++) t.push({
        dataValue: h,
        selectorText: h.toString()
      });
      return t;
    }
  }, {
    key: "loadMoreYearsBatch",
    value: function loadMoreYearsBatch(t, a) {
      var n = [];
      a || (a = this.max ? Math.min(t + this._yearsBatchSize - 1, this.max.getFullYear()) : t + this._yearsBatchSize - 1);
      for (var e = t; e <= a; e++) n.push({
        dataValue: e,
        selectorText: e.toString()
      });
      return n;
    }
  }, {
    key: "getDatesForMonth",
    value: function getDatesForMonth() {
      var t = [],
        a = new Date(this._contextYear, this._contextMonth, 1),
        n = new Date(this._contextYear, this._contextMonth + 1, 0);
      var e = a.getDay();
      this.sundayStart || (e = e === 0 ? 6 : e - 1);
      for (var o = e; o > 0; o--) t.push({
        date: new Date(this._contextYear, this._contextMonth, 1 - o),
        isCurrentMonth: !1
      });
      for (var _o = 1; _o <= n.getDate(); _o++) t.push({
        date: new Date(this._contextYear, this._contextMonth, _o),
        isCurrentMonth: !0
      });
      var d = 6 * 7 - t.length;
      for (var _o2 = 1; _o2 <= d; _o2++) t.push({
        date: new Date(this._contextYear, this._contextMonth + 1, _o2),
        isCurrentMonth: !1
      });
      return t;
    }
  }, {
    key: "isSameDate",
    value: function isSameDate(t, a) {
      return !t || !a ? !1 : t.getFullYear() === a.getFullYear() && t.getMonth() === a.getMonth() && t.getDate() === a.getDate();
    }
  }, {
    key: "isDateInRange",
    value: function isDateInRange(t) {
      return !this._startDate || !this._endDate ? !1 : t >= this._startDate && t <= this._endDate;
    }
  }, {
    key: "isTodayDisabled",
    value: function isTodayDisabled() {
      return this.min && this.max ? this._todaysDate < this.min || this._todaysDate > this.max : this.min ? this._todaysDate < this.min : this.max ? this._todaysDate > this.max : !1;
    }
  }, {
    key: "isDateOutsideMinMax",
    value: function isDateOutsideMinMax(t) {
      return this.min && this.max ? t < this.min || t > this.max : this.min ? t < this.min : this.max ? t > this.max : !1;
    }
  }, {
    key: "setSelectedDate",
    value: function setSelectedDate(t) {
      t ? this._selectedDate = new Date(t) : this._selectedDate = null;
    }
  }, {
    key: "setRangeStart",
    value: function setRangeStart(t) {
      t ? this._startDate = new Date(t) : this._startDate = null;
    }
  }, {
    key: "setRangeEnd",
    value: function setRangeEnd(t) {
      t ? this._endDate = new Date(t) : this._endDate = null;
    }
  }, {
    key: "clearSelection",
    value: function clearSelection() {
      this.range ? (this._startDate = null, this._endDate = null) : this._selectedDate = null;
    }
  }, {
    key: "dispatchChangeEvent",
    value: function dispatchChangeEvent() {
      this.range ? this.dispatchDateRangeChangeEvent() : this.dispatchDateChangeEvent();
    }
  }, {
    key: "dispatchDateChangeEvent",
    value: function dispatchDateChangeEvent() {
      var t = new CustomEvent("dateChange", {
        bubbles: !0,
        composed: !0,
        detail: {
          date: this._selectedDate
        }
      });
      this.dispatchEvent(t);
    }
  }, {
    key: "dispatchDateRangeChangeEvent",
    value: function dispatchDateRangeChangeEvent() {
      var t = new CustomEvent("rangeChange", {
        bubbles: !0,
        composed: !0,
        detail: {
          startDate: this._startDate,
          endDate: this._endDate
        }
      });
      this.dispatchEvent(t);
    }
  }]);
}(u);
s([l()], i.prototype, "_todaysDate");
s([r({
  type: Boolean
})], i.prototype, "range");
s([r({
  type: Date,
  attribute: "start-date"
})], i.prototype, "startDate");
s([r({
  type: Date,
  attribute: "start-date"
})], i.prototype, "endDate");
s([r({
  type: Date,
  attribute: "selected-date"
})], i.prototype, "selectedDate");
s([r({
  type: Date
})], i.prototype, "min");
s([r({
  type: Date
})], i.prototype, "max");
s([r({
  type: Boolean,
  attribute: "sunday-start"
})], i.prototype, "sundayStart");
s([r({
  type: String,
  attribute: "locale"
})], i.prototype, "locale");
s([l()], i.prototype, "_selectedDate");
s([l()], i.prototype, "_startDate");
s([l()], i.prototype, "_endDate");
s([l()], i.prototype, "_contextDate");
s([l()], i.prototype, "_contextMonth");
s([l()], i.prototype, "_contextYear");
s([l()], i.prototype, "_contextDays");
export { i as NjcDatepicker };